import {ActivatedRouteSnapshot, ResolveFn, RouterStateSnapshot} from "@angular/router";
import {Observable} from "rxjs";
import {ListSortOrder, PagedFilter, Pages, StatementImport, StatementImportFilter} from "@model";
import {AccountStatementsService} from "@services";
import {inject} from "@angular/core";
import dayjs from "dayjs";

export const AccountStatementsReslover: ResolveFn<Observable<StatementImport[]>|StatementImport[]> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
  accountStatementsService: AccountStatementsService = inject(AccountStatementsService)
  ): Observable<StatementImport[]>|StatementImport[] => {
  let startDate = dayjs().add(-1, 'years');
  let endDate = dayjs().add(1, 'years');

  return accountStatementsService.findImports(new PagedFilter(new Pages(), new StatementImportFilter(startDate.toDate(), endDate.toDate()),
   ListSortOrder.DESC));
};
